// extracted by mini-css-extract-plugin
export default {"eye":"loginStyles_eye__tcyZB"};